import dayjs, { Dayjs } from 'dayjs';
import { create } from 'zustand';

type State = {
  lastUpdate: Dayjs;
  refreshTrigger: string;
  refreshInterval: number;
  callRefresh: () => void;
};
// let interval: number = 0;
export const useRefreshSyncStore = create<State>()((set, get) => {
  const state = {
    lastUpdate: dayjs(),
    refreshTrigger: '',
    refreshInterval: 15000, // 15 seconds

    callRefresh: async () => {
      const date = dayjs();
      set({ lastUpdate: date, refreshTrigger: date.toISOString() });
    },
  };

  // clearInterval(interval);
  // interval = +setInterval(() => {
  //   state.callRefresh();
  // }, state.refreshInterval);
  return state;
});
